import { createFileRoute } from '@tanstack/react-router';

import { Dashboard } from '@features/dashboard';

export const Route = createFileRoute('/_artworks/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Dashboard />;
}
